import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=f23f3926&scoped=true"
import script from "./CompanySelect.vue?vue&type=script&lang=js"
export * from "./CompanySelect.vue?vue&type=script&lang=js"
import style0 from "./CompanySelect.vue?vue&type=style&index=0&id=f23f3926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23f3926",
  null
  
)

export default component.exports